import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import {
  TextField, Card,
  CardContent,
  Typography,
  Button,
  Box, Snackbar,
  Alert,
  Backdrop, Container,
  CircularProgress,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import { investorApi } from "../../api/api";
import { useEffect } from "react";

const PaymentStatusPage = () => {
  const location = useLocation();
  const { propertyName, investorName, amountInvested,investmentId } = location.state || {}; 

  const [inputValue, setInputValue] = useState(propertyName || ''); 
  const [payInvestorName, setInvestedAmountValue] = useState(investorName || '');
  const [payamountinInvested, setAmountinInvested] = useState(amountInvested || '');
  const [loading, setLoading] = useState(false); 
  const [documentUrl, setDocumentUrl] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false); 
  const [snackbarMessage, setSnackbarMessage] = useState(""); 
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); 
  const [status, setStatus] = useState(''); // For approved/rejected status
  const [comments, setComments] = useState(''); // For comments textarea

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const validate = () => {
    let isValid = true;

    if (!inputValue || inputValue.trim() === '') {
      alert('Property name is required.');
      isValid = false;
    }
    if (!status) {
      alert('Status is required.');
      isValid = false;
    }
    return isValid;
  };

  const savePaymentStatus = async (event) => {

    event.preventDefault();

    if (!validate()) return setLoading(true);

    const formData = new FormData();
    // formData.append("propertyName", inputValue);
    // formData.append("InvestorName", payInvestorName);
    // formData.append("amountinInvested", payamountinInvested);
    formData.append("status", status);
    formData.append("comments", comments);
    

    // console.log("FormData submitted:", formData);

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    try {
      const response = await investorApi.updateInvestmentPayment(investmentId, formData);
      
      const data=response.data;

      
      setSnackbarMessage( "Approved Payment");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
   
    } catch (error) {
      setSnackbarMessage("Rejected");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const [screenshotUrl, setScreenshotUrl] = useState("");
  const [open, setOpen] = useState(false);
  // const [loading, setLoading] = useState(false);

  // Function to fetch the screenshot
  useEffect(() => {
    const fetchScreenshot = async () => {

      if (!investmentId) return; // Prevent API call if investmentId is not set
  
      setLoading(true);
      try {
        
        const response = await investorApi.getPaymentScreenshot(investmentId);
        const data = response.data;
       
        setScreenshotUrl(data.screenshot_path);

  
       
      } catch (error) {
        console.error("Error fetching screenshot:", error);
        // alert("Failed to fetch payment screenshot.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchScreenshot();
  }, [investmentId]); 
  const cancelPaymentStatus = () => {
    window.location.href = "/investment/payment"; 
  };
  const handleOpenModal = (url) => {
    
    setDocumentUrl(url); // Set the document URL to show in preview
    setOpenModal(true); // Open modal
  };
  const handleCloseModal = () => {
    setOpenModal(false); // Close modal
    setDocumentUrl(""); // Clear document URL
  };
  

  return (
    <Container sx={{ width: "100%" }}>
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box sx={{ margin: "2rem auto", padding: "2rem", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", backgroundColor: "#fff", maxWidth: '80%' }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
          <Typography variant="h4" component="h1" sx={{ color: '#13216e', fontWeight: 600, fontSize: '24px' }}>
            Payment Status
          </Typography>
          <Box>
            <Link to="/property/propertyList" style={{ textDecoration: "none", color: '#4e0dff', fontSize: '18px' }}>
              Home
            </Link>
            <BsArrowRight style={{ margin: "-2px 8px", color: "#4e0dff" }} />
            <Link to="#" style={{ textDecoration: "none", color: "#4e0dff", fontSize: '18px' }}>
              Investment
            </Link>
          </Box>
        </Box>

        <Grid container spacing={2}>
          <Card sx={{ width: "100%", marginBottom: 3, marginLeft: 2 }}>
            <CardContent>
              <Typography variant="h5" sx={{ color: "#4E0DFF", fontSize: "20px" }}>
                {inputValue },
              </Typography>
              <Typography variant="subtitle1" sx={{ color: "#13216E", fontSize: "16px" }}>
                {payInvestorName },
              </Typography>
              <Typography variant="subtitle1" sx={{ color: "#13216E", fontSize: "16px" }}>
                {payamountinInvested || "100000"}.
              </Typography>
            </CardContent>
          </Card>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ color: "#13216e", fontWeight: 600, fontSize: "18px" }}>
              Payment Screenshot
            </Typography>
            <a href="#"
            onClick={() => handleOpenModal(screenshotUrl)} // Open modal with the document URL
            style={{ color: "#4e0dff", textDecoration: "underline" }}>
              {screenshotUrl}
            </a>
          </Grid>
          <Grid item xs={12}>
            {/* Dropdown for Approval/Rejection */}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                label="Status"
              >
                <MenuItem value="approved">Approved</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
              </Select>
            </FormControl>

            {/* Textarea for comments */}
            <TextField
              label="Comments"
              multiline
              rows={4}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              fullWidth
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
            <Button variant="contained" color="primary" onClick={savePaymentStatus} disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={cancelPaymentStatus}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
       {/* Modal Dialog for Document Preview */}
       <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="md" >
        <DialogTitle>Document Preview</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            {/* Embed document preview (PDF example) */}
            <embed
              src={documentUrl}
              width="100%"
              height="500px"
              type="application/pdf"
            />
          </Box>
          <Box sx={{ mt: 2 }}>
            {/* Download button */}
            <a href={documentUrl} download>
              <Button variant="contained" color="primary">
                Download Document
              </Button>
            </a>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default PaymentStatusPage;